import { render, staticRenderFns } from "./PointCard.vue?vue&type=template&id=455abc09&scoped=true"
import script from "./PointCard.vue?vue&type=script&lang=js"
export * from "./PointCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455abc09",
  null
  
)

export default component.exports